import { faMoon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppointmentOrderItem } from '@spike/order-model';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './BoardingInfo.module.scss';
import moment from 'moment-timezone';

export interface BoardingInfoProps {
    appointmentItem: AppointmentOrderItem;
}

export const BoardingInfo: FunctionComponent<BoardingInfoProps> = props => {
    const appointment = props.appointmentItem.appointment;

    return (
        <div className={styles.boardingData}>
            <span className={styles.serviceName}>
                <span className={clsx(styles.serviceNameText, styles.rightSpace, styles.widthItem)}>Check In</span>
                <span className={clsx(styles.priceAndDuration, styles.spacing)}>
                    {appointment.duration?.from?.format('ll')} · {appointment.duration?.from?.format('LT')}
                </span>
            </span>
            <span className={clsx(styles.serviceName, styles.centered)}>
                <span className={clsx(styles.serviceNameText, styles.rightSpace, styles.widthItem)}>Check Out</span>
                <span className={clsx(styles.priceAndDuration, styles.spacing)}>
                    {appointment.duration?.to?.format('ll')} · {appointment.duration?.to?.format('LT')}
                </span>
            </span>
            <span className={clsx(styles.serviceName, styles.centered, styles.lastitem)}>
                <span className={clsx(styles.serviceNameText, styles.rightSpace, styles.widthItem)}>Nights</span>
                <span className={clsx(styles.priceAndDuration, styles.spacing)}>
                    <FontAwesomeIcon
                        icon={faMoon}
                        className={styles.iconNights}
                    />
                    {appointment.nightsCount ?? 0} Nights
                </span>
            </span>
        </div>
    );
};

export default BoardingInfo;
